import React from 'react';

export default ({ inView = false }) => {
  return (
    <svg
      className="block"
      width="100%"
      height="100%"
      viewBox="0 0 716 566"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMaxYMax meet"
    >
      <path
        d="M332.964 557.123L530.679 461.274L580.191 472.741L716 392.204V565.674H333.428L332.964 557.123Z"
        fill="#04132E"
      />
      <path
        d="M29.5965 477.514H29.2651V477.912H29.5965V480.961H29.2651V481.358H29.5965V484.408H29.2651V484.805H29.5965V487.855H29.2651V488.252H29.5965V491.301H29.2651V491.699H29.5965V494.748H29.2651V495.146H29.5965V498.195H29.2651V498.593H29.5965V501.642H29.2651V502.04H29.5965V505.089H29.2651V505.487H29.5965V508.536H29.2651V508.933H29.5965V511.983H29.2651V512.38H29.5965V515.429H29.2651V515.827H29.5965V518.876H29.2651V519.274H29.5965V522.323H29.2651V522.721H29.5965V525.77H29.2651V526.168H29.5965V529.217H29.2651V529.615H29.5965V532.664H29.2651V533.062H29.5965V536.111H29.2651V536.508H29.5965V539.558H29.2651V539.955H29.5965V543.004H29.2651V543.402H29.5965V546.451H29.2651V546.849H29.5965V549.898H29.2651V550.296H29.5965V553.345H29.2651V553.743H29.5965V556.792H29.2651V557.19H29.5965V560.239H29.2651V560.637H29.5965V563.686H29.2651V564.083H29.5965V565.608H353.245V552.682H390.296V540.088H390.561H391.821H395.466H396.726H400.371H401.63H405.276H406.535H410.181H411.44H415.085H416.345H418.93V485.667H416.345V485.071C416.345 484.938 416.212 484.872 416.08 484.872H415.417C415.35 484.872 415.284 484.872 415.284 484.938V481.69C415.35 481.69 415.35 481.756 415.417 481.756H416.212C416.345 481.756 416.477 481.69 416.477 481.557V481.358H419.062V423.292H416.477V422.695C416.477 422.563 416.345 422.497 416.212 422.497H415.417C415.35 422.497 415.284 422.497 415.284 422.563V419.315C415.35 419.315 415.35 419.381 415.417 419.381H416.212C416.345 419.381 416.477 419.315 416.477 419.182V418.983H419.062V360.851H416.477V360.254C416.477 360.121 416.345 360.055 416.212 360.055H415.417C415.35 360.055 415.284 360.055 415.284 360.121V358.067H409.717V356.608H387.711V358.067H382.144V360.121C382.078 360.055 382.011 360.055 381.945 360.055H381.15C381.017 360.055 380.885 360.121 380.885 360.254V360.851H378.3V361.049V365.225H376.179V361.977H366.7V365.225H361.729V519.804H353.378V513.109V424.154H349.6V428.396H346.419V432.705H334.289V432.572V390.878L334.422 390.613L334.289 390.547V368.937H333.825V353.294H333.693V368.937H333.229V390.679L323.353 407.582H323.088V408.046L321.099 411.427V411.493L297.039 452.789V452.856L291.207 462.865H291.008V513.242H287.296V530.94H284.115V447.818H280.005V431.71H277.221V424.883H271.389H265.556H255.614V410.366H254.819V424.883H243.882H238.049H232.217V431.71H229.499V447.818H226.119V506.68L220.618 442.515H220.816V439.93H220.551L222.739 388.094H224.661V385.575H230.361H230.692L231.289 382.592H238.182V379.808H231.885L232.614 376.428H238.248V373.577H233.211L233.808 370.595H238.248V367.811H234.404L235.001 364.828H238.248V362.044H235.597L235.862 360.652C235.929 360.519 235.929 360.453 235.929 360.32C235.929 360.121 235.862 359.923 235.73 359.657C233.542 359.591 231.421 359.459 229.3 359.459V358H225.655V347.196H224.131V344.677H225.655V340.302H221.479V339.308H216.177L215.647 330.492V306.629C215.647 306.629 215.845 304.441 215.647 302.983C216.575 302.85 217.304 302.254 217.304 301.525C217.304 300.729 216.376 300 215.183 300C214.056 300 213.062 300.663 213.062 301.525C213.062 302.187 213.658 302.784 214.52 302.917C214.321 304.375 214.52 306.629 214.52 306.629V330.492L213.99 339.308H208.356V340.302H204.18V344.677H205.704V347.196H204.18V357.934H200.535V359.392C196.491 359.525 194.105 359.591 194.105 359.591C193.973 359.79 193.907 359.989 193.907 360.254C193.907 360.387 193.907 360.519 193.973 360.585L194.238 361.911H193.641V364.695H194.834L195.497 367.678H193.641V370.462H196.094L196.757 373.445H193.641V376.229H197.353L198.082 379.609H193.641V382.393H198.679L199.275 385.045C199.275 385.178 199.275 385.244 199.342 385.376H205.241V387.895H207.096L209.284 440.129V441.786L200.004 559.907H198.679V447.619H185.224H185.025H154.006V560.106H137.17V429.258H125.704H121.594H112.978H109.597H97.4017V506.216L93.69 504.492V502.305H77.9815V504.426C77.9815 504.426 75.0651 506.149 72.0162 507.873V464.19H71.9499V456.7V453.187H72.0825V452.723H72.0162V450.933H72.0825V450.469H72.0162V447.95H72.0825V443.443V440.526H71.022V423.292H70.6243V440.526H69.4313V443.443H67.5091V447.42H61.8753V450.469H60.9473V450.933H61.8753V452.723H60.9473V453.187H61.8753V456.7H59.4891V464.19H37.4177V466.776H36.6223V467.372H37.4177V468.433H36.6223V469.029H37.4177V469.294V470.09H36.6223V470.686H37.4177V472.808H29.5965V474.001H29V474.664H29.5965V477.514ZM328.589 400.423L333.229 392.469V407.648H328.589V400.423ZM328.589 408.245H333.229V416.531H328.589V408.245ZM328.589 417.194H333.229V425.281H328.589V417.194ZM328.589 425.943H333.229V432.572H328.589V425.943ZM327.661 401.948V407.582H324.413L327.661 401.948ZM322.027 411.692L324.016 408.245H327.727V416.531H322.027V411.692ZM322.027 417.194H327.727V425.281H322.027V417.194ZM322.027 425.943H327.727V432.572H322.027V425.943ZM321.099 413.216V416.531H319.177L321.099 413.216ZM316.327 421.436L318.779 417.194H321.099V425.281H316.327V421.436ZM316.327 425.943H321.099V432.572H316.327V425.943ZM315.399 422.961V425.281H314.074L315.399 422.961ZM313.676 425.943H315.399V432.572H309.765L313.676 425.943ZM309.235 433.566V442.515H303.999L309.235 433.566ZM303.203 443.907V452.723H298.034L303.203 443.907ZM296.973 454.579V462.865H292.135L296.973 454.579ZM284.115 554.074H287.296V560.106H284.115V554.074ZM219.955 388.094H222.142L219.955 439.797V388.094ZM207.825 388.094H210.278V439.93H210.013L207.825 388.094ZM210.013 442.515H210.278V503.631H205.174L210.013 442.515ZM205.174 503.697V506.282H210.278V558.979H219.955V506.282H225.058V503.697H219.955V442.515L226.119 514.303V560.106H200.667L205.174 503.697Z"
        fill="#04132E"
      />
      <path
        d="M208.024 538.497C208.223 538.298 208.422 538.099 208.555 537.9C208.356 538.033 208.223 538.232 208.024 538.497Z"
        fill="#8CC75A"
      />
      <path
        d="M160.369 552.682C160.236 552.682 160.104 552.682 159.971 552.748C160.104 552.682 160.236 552.682 160.369 552.682Z"
        fill="#8CC75A"
      />
      <path
        d="M197.685 519.274C197.552 519.473 197.42 519.672 197.287 519.871C197.42 519.672 197.552 519.473 197.685 519.274Z"
        fill="#8CC75A"
      />
      <path
        d="M197.684 562.824C197.684 562.824 190.791 562.89 190.46 559.178C190.128 555.466 197.088 539.558 197.684 539.558V562.824Z"
        fill="#0F3163"
      />
      <path
        d="M197.684 562.824C197.684 562.824 204.577 562.89 204.909 559.178C205.24 555.466 198.281 539.558 197.684 539.558C197.684 539.558 197.684 562.824 197.684 562.824Z"
        fill="#143673"
      />
      <path
        d="M198.347 562.824H197.684V565.674H198.347V562.824Z"
        fill="#143673"
      />
      <path
        d="M197.018 565.677H197.681V562.827H197.018V565.677Z"
        fill="#0F3163"
      />
      <path
        d="M544.267 559.841H542.61V565.674H544.267V559.841Z"
        fill="#0F3163"
      />
      <path
        d="M545.924 559.841H544.267V565.674H545.924V559.841Z"
        fill="#143673"
      />
      <path
        d="M544.333 559.974C544.333 559.974 532.668 560.438 531.74 552.616C530.812 544.86 542.676 510.723 544.333 510.723V559.974Z"
        fill="#0F3163"
      />
      <path
        d="M544.267 559.974C544.267 559.974 555.933 560.438 556.86 552.616C557.788 544.86 545.924 510.723 544.267 510.723V559.974Z"
        fill="#143673"
      />
      <path
        d="M269.731 485.534H263.302V495.676H269.731V485.534Z"
        fill="#0F3163"
      />
      <path d="M290.014 520.6H202.854V565.674H290.014V520.6Z" fill="#143673" />
      <path
        d="M199.143 520.6L246.401 473.271L299.028 520.6H199.143Z"
        fill="#143673"
      />
      <path
        d="M193.84 520.6L223.401 491.036L256.21 520.6H193.84Z"
        fill="#143673"
      />
      <path
        d="M233.476 534.984H215.713V564.547H233.476V534.984Z"
        fill="#0F3163"
      />
      <path
        d="M231.686 537.635H217.569V564.614H231.686V537.635Z"
        fill="#061838"
      />
      <path d="M217.569 545.126V543.8H231.686V545.126" fill="#143673" />
      <path d="M217.569 555.93V554.67H231.686V555.93" fill="#143673" />
      <path
        d="M232.283 542.673H217.171V543.866H232.283V542.673Z"
        fill="#0F3163"
      />
      <path
        d="M232.283 553.478H217.171V554.671H232.283V553.478Z"
        fill="#0F3163"
      />
      <path
        d="M235.531 563.752H213.724V565.674H235.531V563.752Z"
        fill="#0F3163"
      />
      <path
        d="M282.391 530.277H247.395V555.864H282.391V530.277Z"
        fill="#0F3163"
      />
      <path
        d="M280.867 532.067H249.052V554.074H280.867V532.067Z"
        fill="#061838"
      />
      <path
        d="M281.994 542.541H275.101V531.537H273.974V542.541H268.738V531.537H267.545V542.541H262.308V531.537H261.115V542.541H255.879V531.537H254.752V542.541H248.456V543.601H254.752V554.87H255.879V543.601H261.115V554.87H262.308V543.601H267.545V554.87H268.738V543.601H273.974V554.87H275.101V543.601H281.994V542.541Z"
        fill="#0F3163"
      />
      <path
        d="M290.014 520.732H202.854V523.318H290.014V520.732Z"
        fill="#0F3163"
      />
      <path
        d="M201.86 565.674H199.408V553.743L200.667 552.02L201.86 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M197.419 565.674H194.967V553.743L196.226 552.02L197.419 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M192.979 565.674H190.526V553.743L191.785 552.02L192.979 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M188.538 565.674H186.085V553.743L187.345 552.02L188.538 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M184.163 565.674H181.711V553.743L182.97 552.02L184.163 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M201.595 565.674H199.143V553.743L200.402 552.02L201.595 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M197.154 565.674H194.702V553.743L195.961 552.02L197.154 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M192.78 565.674H190.261V553.743L191.521 552.02L192.78 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M188.339 565.674H185.886V553.743L187.146 552.02L188.339 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M183.898 565.674H181.446V553.743L182.705 552.02L183.898 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M202.854 555.665H180.12V558.184H202.854V555.665Z"
        fill="#061838"
      />
      <path
        d="M202.854 560.769H180.12V563.288H202.854V560.769Z"
        fill="#061838"
      />
      <path d="M202.854 555.4H180.12V557.919H202.854V555.4Z" fill="#143673" />
      <path
        d="M202.854 560.504H180.12V563.023H202.854V560.504Z"
        fill="#143673"
      />
      <path
        d="M311.754 565.674H309.302V553.743L310.561 552.02L311.754 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M307.313 565.674H304.86V553.743L306.12 552.02L307.313 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M302.872 565.674H300.42V553.743L301.679 552.02L302.872 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M298.431 565.674H295.979V553.743L297.238 552.02L298.431 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M294.057 565.674H291.604V553.743L292.797 552.02L294.057 553.743V565.674Z"
        fill="#061838"
      />
      <path
        d="M311.489 565.674H309.036V553.743L310.295 552.02L311.489 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M307.048 565.674H304.595V553.743L305.855 552.02L307.048 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M302.607 565.674H300.155V553.743L301.414 552.02L302.607 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M298.232 565.674H295.78V553.743L297.039 552.02L298.232 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M293.792 565.674H291.339V553.743L292.599 552.02L293.792 553.743V565.674Z"
        fill="#143673"
      />
      <path
        d="M312.748 555.665H290.014V558.184H312.748V555.665Z"
        fill="#061838"
      />
      <path
        d="M312.748 560.769H290.014V563.288H312.748V560.769Z"
        fill="#061838"
      />
      <path d="M312.748 555.4H290.014V557.919H312.748V555.4Z" fill="#143673" />
      <path
        d="M312.748 560.504H290.014V563.023H312.748V560.504Z"
        fill="#143673"
      />
      <path
        d="M226.185 493.688L256.21 520.733H262.706L229.102 490.705L226.185 493.688Z"
        fill="#0F3163"
      />
      <path
        d="M325.672 523.45L314.67 544.728H319.177L311.488 562.161H325.606L325.672 523.45Z"
        fill="#0F3163"
      />
      <path
        d="M325.606 523.45L336.609 544.728H332.101L339.79 562.161H325.606V523.45Z"
        fill="#143673"
      />
      <path
        d="M325.606 562.161H323.352V565.674H325.606V562.161Z"
        fill="#0F3163"
      />
      <path
        d="M327.859 562.161H325.606V565.674H327.859V562.161Z"
        fill="#143673"
      />
      <path
        d="M716 565.674H652.039V474.73L716 508.337V565.674Z"
        fill="#143673"
      />
      <path
        d="M676.033 506.879H658.137V526.234H676.033V506.879Z"
        fill="#0F3163"
      />
      <path
        d="M674.575 508.205H659.529V524.842H674.575V508.205Z"
        fill="#061838"
      />
      <path
        d="M658.493 516.068L658.493 516.93L675.659 516.93L675.659 516.068L658.493 516.068Z"
        fill="#0F3163"
      />
      <path
        d="M701.683 506.879H683.787V526.234H701.683V506.879Z"
        fill="#0F3163"
      />
      <path
        d="M700.225 508.205H685.179V524.842H700.225V508.205Z"
        fill="#061838"
      />
      <path
        d="M684.141 516.066L684.141 516.928L701.307 516.928L701.307 516.066L684.141 516.066Z"
        fill="#0F3163"
      />
      <path
        d="M693.266 532.333H673.249V565.674H693.266V532.333Z"
        fill="#0F3163"
      />
      <path
        d="M691.277 535.315H675.304V565.674H691.277V535.315Z"
        fill="#061838"
      />
      <path
        d="M674.894 540.991L674.894 542.317L691.928 542.317L691.928 540.991L674.894 540.991Z"
        fill="#0F3163"
      />
      <path
        d="M674.876 558.045L674.876 559.371L691.91 559.371L691.91 558.045L674.876 558.045Z"
        fill="#0F3163"
      />
      <path
        d="M684.053 540.95H682.727V557.985H684.053V540.95Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 565.674H565.675V413.614L652.37 447.354V565.674Z"
        fill="#143673"
      />
      <path d="M652.37 447.42H565.675V450.403H652.37V447.42Z" fill="#0F3163" />
      <path
        d="M652.37 453.054H565.675V456.037H652.37V453.054Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 459.749H565.675V462.732H652.37V459.749Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 465.384H565.675V468.367H652.37V465.384Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 472.078H565.675V475.061H652.37V472.078Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 477.713H565.675V480.696H652.37V477.713Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 484.408H565.675V487.391H652.37V484.408Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 490.042H565.675V493.025H652.37V490.042Z"
        fill="#0F3163"
      />
      <path d="M652.37 496.737H565.675V499.72H652.37V496.737Z" fill="#0F3163" />
      <path
        d="M652.37 502.371H565.675V505.354H652.37V502.371Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 509.066H565.675V512.049H652.37V509.066Z"
        fill="#0F3163"
      />
      <path d="M652.37 514.7H565.675V517.683H652.37V514.7Z" fill="#0F3163" />
      <path
        d="M652.37 521.395H565.675V524.378H652.37V521.395Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 527.096H565.675V530.012H652.37V527.096Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 533.724H565.675V536.707H652.37V533.724Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 539.425H565.675V542.408H652.37V539.425Z"
        fill="#0F3163"
      />
      <path d="M652.37 546.12H565.675V549.102H652.37V546.12Z" fill="#0F3163" />
      <path
        d="M652.37 551.754H565.675V554.737H652.37V551.754Z"
        fill="#0F3163"
      />
      <path
        d="M652.37 558.449H565.675V561.432H652.37V558.449Z"
        fill="#0F3163"
      />
      <path
        d="M630.365 459.75H584.234V495.411H630.365V459.75Z"
        fill="#0F3163"
      />
      <path
        d="M628.178 462.269H586.289V492.893H628.178V462.269Z"
        fill="#061838"
      />
      <path
        d="M630.365 516.557H584.234V565.675H630.365V516.557Z"
        fill="#143673"
      />
      <path
        d="M628.178 520.003H586.289V565.741H628.178V520.003Z"
        fill="#0F3163"
      />
      <path
        d="M628.236 524.849L628.236 519.944L586.346 519.944L586.346 524.849L628.236 524.849Z"
        fill="#061838"
      />
      <path
        d="M586.325 565.656L590.964 565.656L590.964 519.918L586.325 519.918L586.325 565.656Z"
        fill="#061838"
      />
      <path
        d="M607.896 460.147H606.636V495.013H607.896V460.147Z"
        fill="#0F3163"
      />
      <path
        d="M399.576 565.675H475.732V432.042L399.576 461.738V565.675Z"
        fill="#143673"
      />
      <path
        d="M475.703 525.483L523.028 525.483L523.028 431.953L475.703 431.953L475.703 525.483Z"
        fill="#143673"
      />
      <path
        d="M514.772 441.985H484.017V465.782H514.772V441.985Z"
        fill="#0F3163"
      />
      <path
        d="M513.38 443.642H485.41V464.124H513.38V443.642Z"
        fill={`${inView ? '#B1F8FC' : '#061838'}`}
      />
      <path
        d="M514.772 490.175H484.017V513.971H514.772V490.175Z"
        fill="#0F3163"
      />
      <path d="M513.38 491.832H485.41V512.314H513.38V491.832Z" fill="#061838" />
      <path
        d="M461.879 469.692H416.543V504.758H461.879V469.692Z"
        fill="#0F3163"
      />
      <path
        d="M459.825 472.145H418.598V502.305H459.825V472.145Z"
        fill="#061838"
      />
      <path
        d="M343.37 565.674H399.576V489.312L343.37 515.562V565.674Z"
        fill="#0F3163"
      />
      <path
        d="M380.951 536.177H363.32V565.475H380.951V536.177Z"
        fill="#0F3163"
      />
      <path
        d="M379.095 538.828H365.11V565.674H379.095V538.828Z"
        fill="#061838"
      />
      <path
        d="M379.095 538.828H365.11V540.75H379.095V538.828Z"
        fill="#143673"
      />
      <path d="M379.493 543.8H364.514V544.993H379.493V543.8Z" fill="#0F3163" />
      <path
        d="M379.493 558.78H364.514V559.973H379.493V558.78Z"
        fill="#0F3163"
      />
      <path d="M372.6 543.8H371.406V558.78H372.6V543.8Z" fill="#0F3163" />
      <path
        d="M459.427 522.456H418.93V565.674H459.427V522.456Z"
        fill="#0F3163"
      />
      <path
        d="M457.638 525.505H420.786V565.674H457.638V525.505Z"
        fill="#061838"
      />
      <path
        d="M457.638 525.505H420.786V529.813H457.638V525.505Z"
        fill="#143673"
      />
      <path
        d="M424.895 525.505H420.786V565.674H424.895V525.505Z"
        fill="#143673"
      />
      <path
        d="M457.571 527.692H424.829V528.554H457.571V527.692Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 530.675H424.829V531.537H457.571V530.675Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 533.725H424.829V534.586H457.571V533.725Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 536.773H424.829V537.635H457.571V536.773Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 539.823H424.829V540.685H457.571V539.823Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 542.872H424.829V543.734H457.571V542.872Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 545.855H424.829V546.717H457.571V545.855Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 548.904H424.829V549.766H457.571V548.904Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 551.953H424.829V552.815H457.571V551.953Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 555.002H424.829V555.864H457.571V555.002Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 557.985H424.829V558.847H457.571V557.985Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 561.034H424.829V561.896H457.571V561.034Z"
        fill="#0F3163"
      />
      <path
        d="M457.571 564.083H424.829V564.945H457.571V564.083Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 527.692H420.786V528.554H424.895V527.692Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 530.675H420.786V531.537H424.895V530.675Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 533.725H420.786V534.586H424.895V533.725Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 536.773H420.786V537.635H424.895V536.773Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 539.823H420.786V540.685H424.895V539.823Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 542.872H420.786V543.734H424.895V542.872Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 545.855H420.786V546.717H424.895V545.855Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 548.904H420.786V549.766H424.895V548.904Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 551.953H420.786V552.815H424.895V551.953Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 555.002H420.786V555.864H424.895V555.002Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 557.985H420.786V558.847H424.895V557.985Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 561.034H420.786V561.896H424.895V561.034Z"
        fill="#0F3163"
      />
      <path
        d="M424.895 564.083H420.786V564.945H424.895V564.083Z"
        fill="#0F3163"
      />
      <path
        d="M347.346 528.554H395.599V498.858L347.346 519.804V528.554Z"
        fill="#143673"
      />
      <path
        d="M349.534 526.565H393.412V502.04L349.534 520.865V526.565Z"
        fill="#061838"
      />
      <path
        d="M518.411 565.695L521.195 565.695L521.195 525.526L518.411 525.526L518.411 565.695Z"
        fill="#143673"
      />
      <path
        d="M475.754 525.483L480.659 525.483L480.659 431.953L475.754 431.953L475.754 525.483Z"
        fill="#0F3163"
      />
      <path
        d="M438.682 469.692H437.356V503.896H438.682V469.692Z"
        fill="#0F3163"
      />
      <path
        d="M500.057 442.515H498.731V464.588H500.057V442.515Z"
        fill="#0F3163"
      />
      <path
        d="M500.057 490.771H498.731V513.308H500.057V490.771Z"
        fill="#0F3163"
      />
      <g filter="url(#town_filter0_d)">
        <circle
          cx="499"
          cy="454"
          r="26"
          fill={`${inView ? '#B1F8FC' : 'none'}`}
          fillOpacity="0.01"
        />
      </g>
      <g>
        <rect x="288" y="392" width="109" height="3" fill="#143673" />
        <rect
          width="82"
          height="1"
          transform="matrix(1 0 0 -1 376 414)"
          fill="#143673"
        />
        <rect
          width="82"
          height="1"
          transform="matrix(1 0 0 -1 652 357)"
          fill="#143673"
        />
        <rect y="514" width="129" height="1" fill="#143673" />
        <rect x="88" y="470" width="93" height="3" fill="#143673" />
        <rect x="612" y="374" width="64" height="3" fill="#143673" />
      </g>
      <defs>
        <filter
          id="town_filter0_d"
          x="453"
          y="408"
          width="92"
          height="92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.694118 0 0 0 0 0.972549 0 0 0 0 0.988235 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
